import { type GroupContext, type UserContext } from '../types/context'

export function enrichEventProperties(properties: Record<string, any>, userContext: UserContext, groupContext: GroupContext): Record<string, any> {
  return {
    ...properties,
    ...userContext,
    ...groupContext,
    timestamp: new Date().toISOString(),
    url: window.location.href,
    path: window.location.pathname,
    userAgent: navigator.userAgent,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight
    // Add any other automatic properties here
  }
}
